<template>
    <div v-click-outside="collapse" class="compact-build-checklist" :class="{extended: getWidth < 584 ? true :extended}">
        <div v-if="getWidth > 584" :style="[!extended ? { 'justify-self': 'center' } : {}]" class="menu-option menu-toggle-row">
            <button
                type="button"
                class="menu-toggle-button"
                :class="{'is-expanded': getWidth < 584 ? true :extended}"
                :aria-expanded="String(getWidth < 584 ? true :extended)"
                aria-label="Toggle build checklist"
                @click="extend(!extended)"
            >
                <span class="menu-link icon icon-chevron-thin-right"></span>
            </button>
            <div v-if="extended && hasSelectedParts" class="compact-status-indicator" @click.stop>
                <div v-if="getBuidStatus && getBuidStatus == 'warning'" class="indicator">
                    <span
                        class="icon icon-warning warning-switch"
                        role="button"
                        tabindex="0"
                        v-gixtip="statusTip()"
                        @click.stop="openBuildOverview"
                        @keydown.enter.prevent="openBuildOverview"
                        @keydown.space.prevent="openBuildOverview"
                    ></span>
                </div>
                <div v-if="getBuidStatus && getBuidStatus == 'ok'" class="indicator">
                    <span
                        class="icon icon-check indicate-ok"
                        role="button"
                        tabindex="0"
                        v-gixtip="statusTip()"
                        @click.stop="openBuildOverview"
                        @keydown.enter.prevent="openBuildOverview"
                        @keydown.space.prevent="openBuildOverview"
                    ></span>
                </div>
                <div v-if="getBuidStatus && getBuidStatus == 'sad'" class="indicator">
                    <span
                        class="icon icon-circle-with-cross indicate-sad"
                        role="button"
                        tabindex="0"
                        v-gixtip="statusTip()"
                        @click.stop="openBuildOverview"
                        @keydown.enter.prevent="openBuildOverview"
                        @keydown.space.prevent="openBuildOverview"
                    ></span>
                </div>
            </div>
        </div>
        <div v-else style="height: 15px;">

        </div>
        <div
            v-on:click="emitTypeChange(option.type), extend(false)"
            v-for="(option) in allMenuOptions"
            :key="option.item.id"
            class="menu-option"
            :class="{
                'option-active': $route.name == option.type.toLowerCase(),
                'option-unavailable': hasUnavailableSelection(option.item.contents)
            }"
        >
            <div class="label-link" :class="{'power': option.type == 'psu'}">
                <router-link  ref="rtrLink"
                    @click.native="setLayout('simple')"
                    :to='option.url'
                    class="menu-link"
                    :class="{'is-active': option.name.toLowerCase() == $route.name}"
                    >
                    <span>
                        <div :class="{ selected: option.item.contents!==null, incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" class="b-icon" style="display: inline-block;vertical-align: sub;" v-html="iconClasses[option.item.id - 1]"></div>
                        <span
                        v-if="getWidth < 584"
                            style="margin-left: 15px; text-transform: capitalize"
                        >{{option.item.type == 'cpu' ? 'Processor' : option.item.type == 'gpu' ? 'Graphics' : option.item.type == 'psu' ? 'Power Supply' : option.item.type}}</span>
                    </span>
                </router-link> 
            </div>
            <div class="build-item-link" :class="{'is-empty': option.item.contents==null}" v-if="extended == true || getWidth < 584">
                <button v-on:click.stop style="outline: none;" v-if="option.item.contents!==null" @click="unset(option.item)" class="item-label btn-reset"><span class="icon icon-circle-with-cross"></span></button>
                <router-link @click.native="setLayout('simple'), extend(false)" style="margin-top: 3px;" v-if="option.item.contents==null && getWidth > 584" :to="option.url" class="item-label not-selected">Not Selected</router-link>
                <div v-if="option.item.contents!==null && (option.type == 'ram' || option.type == 'gpu' || option.type == 'storage' ||option.type == 'graphics')"  
                    style="display: inline-block; border-color: #1997c6;" class="item-label selected fadeOut"
                    :class="{'current': option.type == $route.name}" >
                    <router-link v-gixtip.truncated="partTooltip(option)" data-gixtip-overflow :class="{incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" @click.native.stop="setLayout('advanced'), extend(false)" style=" text-decoration: none;" :to="option.url+'?view=slider&id='+option.item.contents[0].id + '&redir=true'" class="build-part-name">
                        <span v-if="option.type == 'ram' && option.item.contents.length <2 && option.item.contents.length !==0" class="build-part-name__text" data-gixtip-overflow>{{option.item.contents[0].compat.ram_type + ' ' + parseInt(option.item.contents[0].compat.capacity)}}GB {{option.item.contents[0].brand}}</span>
                        <span v-else-if="option.item.contents.length <2 && option.item.contents.length !==0" class="build-part-name__text" data-gixtip-overflow>{{option.item.contents[0].model}}</span>
                        <span v-if="option.item.contents.length >1 && option.type == 'ram'" class="build-part-name__text" data-gixtip-overflow>
                            {{option.item.contents[0].compat['ram_type']}} 
                            {{getItemValue({item: option.item.contents, field: 'capacity'})}}GB 
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                        <span v-if="option.item.contents.length >1 && option.type == 'storage'" class="build-part-name__text" data-gixtip-overflow>
                            {{getItemValue({item: option.item.contents, field: 'capacity'})}}TB
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                        <span v-if="option.item.contents.length >1 && (option.type == 'graphics' || option.type == 'gpu')" class="build-part-name__text" data-gixtip-overflow>
                            {{getItemValue({item: option.item.contents, field: 'model'}).toLowerCase().includes('geforce') ? getItemValue({item: option.item.contents, field: 'model'}).substr(8):getItemValue({item: option.item.contents, field: 'model'})}}
                            <span style="color: #00bc8c; margin:0px;">({{option.item.contents.length}})</span>
                        </span>
                    </router-link>
                    <span
                        v-if="hasUnavailableSelection(option.item.contents)"
                        class="build-unavailable-warning"
                        v-gixtip="'This saved part is no longer available on Amazon.'"
                        tabindex="0"
                        role="img"
                        aria-label="This saved part is no longer available on Amazon."
                    ><span class="icon icon-warning" aria-hidden="true"></span></span>
                </div>
                <div v-else-if="option.item.contents!==null"  :class="{'current': option.item.contents.type == $route.name}" style="display: inline-block; border-color: #1997c6" class="item-label selected fadeOut">
                    <router-link v-gixtip.truncated="partTooltip(option)" data-gixtip-overflow @click.native.stop="setLayout('advanced'), extend(false)" :class="{incompatible: checkPartCompat({compatTable: getStateCompatTable, type: option.name}) == false}" :to="option.url+'?view=slider&id='+option.item.contents.id + '&redir=true'" class="build-part-name">{{option.item.contents.model}}</router-link>
                    <span
                        v-if="hasUnavailableSelection(option.item.contents)"
                        class="build-unavailable-warning"
                        v-gixtip="'This saved part is no longer available on Amazon.'"
                        tabindex="0"
                        role="img"
                        aria-label="This saved part is no longer available on Amazon."
                    ><span class="icon icon-warning" aria-hidden="true"></span></span>
                </div>
            </div>
        </div>
        <div v-if="extended || getWidth < 584" class="build-metrics">
            <div class="metric">
                <div class="metric-head">
                    <span class="metric-label">
                        <span class="icon icon-gauge"></span>
                        Performance
                        <span class="icon icon-info-with-circle metric-info" v-gixtip="perfScoreTip()"></span>
                    </span>
                    <span class="metric-value perf-value">
                        <template v-if="displayPerformancePercent >= 100">High end</template>
                        <template v-else>{{ displayPerformancePercent }}<span class="perf-max">/100</span></template>
                    </span>
                </div>
                <div class="metric-track">
                    <div class="metric-fill perf-fill" :style="{ width: displayPerformancePercent + '%' }"></div>
                </div>
            </div>
            <div class="metric">
                <div class="metric-head">
                    <span class="metric-label"><span class="icon icon-flash"></span>Power</span>
                    <span class="metric-value" :style="{ color: powerMetricColor }">{{ powerMetricText }}</span>
                </div>
                <div class="metric-track">
                    <div class="metric-fill" :style="{ width: displayPowerPercent + '%', background: powerMetricColor }"></div>
                </div>
            </div>
            <TotalCost :expanded="true" :centsShow="false" class="build-total" />
        </div>
        <div  v-if="extended || getWidth < 584" class="menu-optoins-buttons desktop-hide">
            <!-- Same one-click save as the full checklist; the name comes from the
                 shared draft title, not a prompt. -->
            <div
                v-if="saveState !== 'idle'"
                class="drop-down build-save-status"
                :class="'build-save-status--' + saveState"
                role="status"
                aria-live="polite"
                style="text-align: center;"
            >
                <span v-if="saveState == 'saving'">Saving&hellip;</span>
                <span v-else-if="saveState == 'saved'">Saved to <router-link :to="{path: '/users/mybuild'}">My Builds</router-link></span>
                <span v-else-if="saveState == 'signin'">Sign in to save. Your build is kept as it is.</span>
                <span v-else-if="saveState == 'name-required'">
                    Give this build a name first.
                    <button type="button" class="build-name-suggest" @click="useSuggestedName()">Use &ldquo;{{ suggestedBuildName }}&rdquo;</button>
                </span>
                <span v-else>{{ saveErrorText }}</span>
            </div>
        <div class="build-actions">
            <router-link :to="'/users/mybuild'" @click.native="extend(false)"><button class="gc-button">My Builds</button></router-link>
            <button @click="requestNewBuild()" class="gc-button">New build</button>
            <button
                :class="{ inactive: !canSubmitSave }"
                :disabled="!canSubmitSave"
                :title="saveButtonHint"
                @click="submitSave()"
                class="gc-button"
            >{{ saveButtonLabel }}</button>
        </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions }       from 'vuex';
import { EventBus }         from '../../eventBus'
import TotalCost            from './TotalCost.vue';
import {functions}          from '../../functions';
import ClickOutside         from 'vue-click-outside'
import gixtip               from '../../directives/tooltip'
import { hasUnavailableParts } from '../../utils/partAvailability'
import { consumePendingBuildSave, setPendingBuildSave } from '../../utils/pendingSave'
import { selectionTooltip } from '../../utils/buildParts'


// The build overview: where compatibility findings are spelled out.
const BUILD_OVERVIEW_ROUTE = '/builder/home'

export default {
    name: 'MenuCollapsible',
    components: {
        TotalCost
    },
    directives: {
        ClickOutside,
        gixtip,
    },
    props: ['extended'],
    data(){
        return {
            iconClasses:    [
                // CPU
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-cpu-fill" viewBox="0 0 16 16">
                    <path d="M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>
                    <path d="M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5z"/>
                </svg>`,
                // Motherboard
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-motherboard" viewBox="0 0 16 16">
                    <path d="M11.5 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm2 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm-10 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM5 3a1 1 0 0 0-1 1h-.5a.5.5 0 0 0 0 1H4v1h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 0 1 1v.5a.5.5 0 0 0 1 0V8h1v.5a.5.5 0 0 0 1 0V8a1 1 0 0 0 1-1h.5a.5.5 0 0 0 0-1H9V5h.5a.5.5 0 0 0 0-1H9a1 1 0 0 0-1-1v-.5a.5.5 0 0 0-1 0V3H6v-.5a.5.5 0 0 0-1 0V3Zm0 1h3v3H5V4Zm6.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2Z"/>
                    <path d="M1 2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 9H1V8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6H1V5H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 2H1Zm1 11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11Z"/>
                </svg>`,
                // RAM
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"  class="bi bi-memory" viewBox="0 0 16 16">
                    <path d="M1 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707-.293l.353-.353a.5.5 0 0 1 .708 0l.353.353a1 1 0 0 0 .707.293H15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1Zm.5 1h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm5 0h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm4.5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4ZM2 10v2H1v-2h1Zm2 0v2H3v-2h1Zm2 0v2H5v-2h1Zm3 0v2H8v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Z"/>
                </svg>`,
                // Storage
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                    <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                </svg>`,
                // Graphics
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-gpu-card" viewBox="0 0 16 16">
                    <path d="M4 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm7.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
                    <path d="M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .5.5V4h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H2v2.5a.5.5 0 0 1-1 0V2H.5a.5.5 0 0 1-.5-.5Zm5.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM9 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"/>
                    <path d="M3 12.5h3.5v1a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-1Zm4 1v-1h4v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"/>
                </svg>`,
                // PSU
                `<span style="font-size: 28px; " class="icon icon-flash"></span>`,
                // CASE
                `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" class="bi bi-pc" viewBox="0 0 16 16">
                    <path d="M5 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H5Zm.5 14a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM5 1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM5.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z"/>
                </svg>`
            ],
            warnings:       [],
            // idle | saving | saved | signin | error
            saveState:      'idle',
            saveErrorText:  '',
            saveStatusTimer: null,
            routeName:      this.$route.name,
            buildPerformance: 0,
            metricAnimationMs: 700,
            displayPerformancePercent: 0,
            displayPowerPercent: 0,
            displayPowerWatts: 0,
            displayPowerWattage: null,
            metricAnimationFrame: null,
            metricTargets: {
                performance: null,
                powerPercent: null,
                powerWatts: null,
                powerWattage: null
            },
            viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
            saveRequestContext: null,
        }
    },
    watch: {
        routeName(){
    }
    },
    computed: {
        ...mapGetters([
            'allMenuOptions',
            'getBuildRaw',
            'getUser',
            'getError',
            'getBuildAdded',
            'getBuild',
            'getBuildTDP',
            'getStateCompatTable',
            'loggedIn',
            'getBuidStatus',
            'getWarnings',
            'isEditingSavedBuild',
            'getDraftBuildName',
            'canSaveBuild',
            'buildHasParts',
            'hasUnsavedChanges',
            'suggestedBuildName',
        ]),
        getWidth(){
            return this.viewportWidth
        },
        hasSelectedParts(){
            var options = this.allMenuOptions || {}
            var keys = Object.keys(options)
            for(var i = 0; i < keys.length; i++){
                var item = options[keys[i]] && options[keys[i]].item
                var contents = item ? item.contents : null
                if(Array.isArray(contents) && contents.length > 0){
                    return true
                }
                if(contents !== null && contents !== undefined && !Array.isArray(contents)){
                    return true
                }
            }
            return false
        },
        // Shares the store's draft title with the full checklist, so renaming in
        // one place shows up in the other.
        buildName: {
            get(){ return this.getDraftBuildName },
            set(value){ this.setDraftBuildName(value) },
        },
        canSubmitSave(){
            if(!this.buildHasParts){ return false }
            if(this.loggedIn != 'true'){ return true }
            return this.canSaveBuild
        },
        saveButtonLabel(){
            if(this.isEditingSavedBuild && !this.hasUnsavedChanges){
                return 'Saved'
            }
            return 'Save'
        },
        saveButtonHint(){
            if(!this.buildHasParts){ return 'Select at least one part before saving.' }
            if(this.loggedIn != 'true'){ return 'Sign in to save this build.' }
            if(this.isEditingSavedBuild && !this.hasUnsavedChanges){ return 'No changes to save.' }
            return ''
        },
        powerMetricText(){
            if(this.displayPowerWattage){
                return this.displayPowerWatts + ' / ' + this.displayPowerWattage + ' W'
            }
            return this.displayPowerWatts + ' W'
        },
        powerMetricColor(){
            return this.getPowerInfo().color
        },
    },
    methods: {
        openBuildOverview(){
            if(this.$route.path == BUILD_OVERVIEW_ROUTE){ return }
            this.$router.push(BUILD_OVERVIEW_ROUTE).catch(()=>{})
        },
         ...mapActions([
            'updateBuildStatus',
            'rmFromMenu',
            'rmFromBuild',
            'getBuild',
            'getPrice',
            'fetchItems',
            'setCurrentPartType',
            'saveBuild',
            'updateSavedBuild',
            'setDraftBuildName',
            'buildReset',
            'compatTableReset',
            'setLayout',
            'itemsLoaded'
        ]),
        hasUnavailableSelection: (contents) => hasUnavailableParts(contents),
        partTooltip(option){
            var contents = option && option.item ? option.item.contents : null
            return selectionTooltip(contents)
        },
        getPerformance: (build) =>  functions.getBuildPerformance(build),
        getPerformancePercent(){
            var result = this.getPerformance(this.allMenuOptions)
            var total = result && result.Total ? result.Total : 0
            return Math.min(100, Math.round(total / 160 * 100))
        },
        perfScoreTip(){
            var p = this.getPerformancePercent()
            if(p >= 100){
                return 'High-end build - your parts top our 100-point performance scale, benchmarked against a high-end reference build.'
            }
            return 'Performance score: ' + p + ' of 100 - how your selected parts compare to a high-end reference build.'
        },
        statusTip(){
            if(this.getBuidStatus == 'ok'){ return 'All good!' }
            if(this.getWarnings && this.getWarnings.length){ return this.getWarnings.join('\n') }
            if(this.getBuidStatus == 'warning'){ return 'Compatible, with warnings to review. Open the build summary for details.' }
            if(this.getBuidStatus == 'sad'){ return 'Compatibility conflict found. Review the highlighted parts before saving the build.' }
            return 'Build status updates as you select parts.'
        },
        getSelectedPowerWattage(){
            var psu = this.allMenuOptions && this.allMenuOptions.psu && this.allMenuOptions.psu.item.contents
            var wattage = psu && psu.specs && psu.specs.wattage ? parseInt(psu.specs.wattage) : null
            if(isNaN(wattage)){
                return null
            }
            return wattage
        },
        getPowerInfo(){
            var tdp = this.getBuildTDP || 0
            var wattage = this.getSelectedPowerWattage()
            if(!wattage){
                return { percent: 0, color: '#9198aa', watts: tdp, wattage: null }
            }
            var ratio = tdp / wattage
            var color = ratio > 1 ? '#e64759' : ratio > 0.8 ? '#e4d836' : '#00bc8c'
            return {
                percent: Math.min(100, Math.round(ratio * 100)),
                color: color,
                watts: tdp,
                wattage: wattage
            }
        },
        syncMetricTargets(immediate){
            var powerInfo = this.getPowerInfo()
            var targets = {
                performance: this.getPerformancePercent(),
                powerPercent: powerInfo.percent || 0,
                powerWatts: powerInfo.watts || 0,
                powerWattage: powerInfo.wattage || null
            }

            if(this.metricTargets.performance === targets.performance
            && this.metricTargets.powerPercent === targets.powerPercent
            && this.metricTargets.powerWatts === targets.powerWatts
            && this.metricTargets.powerWattage === targets.powerWattage){
                return
            }

            this.metricTargets = targets
            this.displayPowerWattage = targets.powerWattage

            if(immediate){
                this.setMetricDisplays(targets)
                return
            }

            this.animateMetricDisplays(targets)
        },
        setMetricDisplays(targets){
            this.displayPerformancePercent = targets.performance
            this.displayPowerPercent = targets.powerPercent
            this.displayPowerWatts = targets.powerWatts
        },
        animateMetricDisplays(targets){
            if(this.metricAnimationFrame && typeof window !== 'undefined' && window.cancelAnimationFrame){
                window.cancelAnimationFrame(this.metricAnimationFrame)
            }

            if(typeof window === 'undefined' || !window.requestAnimationFrame){
                this.setMetricDisplays(targets)
                return
            }

            var startPerformance = this.displayPerformancePercent || 0
            var startPowerPercent = this.displayPowerPercent || 0
            var startPowerWatts = this.displayPowerWatts || 0
            var duration = this.metricAnimationMs
            var startTime = null
            var self = this

            function easeOutCubic(progress){
                return 1 - Math.pow(1 - progress, 3)
            }

            function step(timestamp){
                if(startTime === null){
                    startTime = timestamp
                }
                var progress = Math.min(1, (timestamp - startTime) / duration)
                var eased = easeOutCubic(progress)
                self.displayPerformancePercent = Math.round(startPerformance + (targets.performance - startPerformance) * eased)
                self.displayPowerPercent = Math.round(startPowerPercent + (targets.powerPercent - startPowerPercent) * eased)
                self.displayPowerWatts = Math.round(startPowerWatts + (targets.powerWatts - startPowerWatts) * eased)

                if(progress < 1){
                    self.metricAnimationFrame = window.requestAnimationFrame(step)
                    return
                }

                self.metricAnimationFrame = null
                self.setMetricDisplays(targets)
            }

            this.metricAnimationFrame = window.requestAnimationFrame(step)
        },
        unset(item) {
            this.rmFromBuild({item: item, id: undefined});
            this.rmFromMenu({item: item, id: undefined});
            item.contents = null;
            this.getPrice() 
        },
        extend(bool, delay){
            setTimeout(() => {
                EventBus.$emit('extended', bool)
            }, typeof(delay) =='number'? delay : 0);
        },
        async emitTypeChange(newType){
            var routeChanging = this.$route.name !== newType
            if(routeChanging){
                this.itemsLoaded(false)
                this.$router.push(newType).catch(()=>{})
            }
            if(newType == 'gpu'){
                newType = 'graphics'
            }
            EventBus.$emit('emitTypeChange', newType)
            this.setCurrentPartType(newType)
        },
        getItemValue({item, field}){
            console.log('getting item value: ', field, ' from ', item)
            var type = ''
            var length = 0
            var capacity = 0
            if(item && typeof(item) == 'object' && item.length >0){
                type = item[0].type
                length = item.length
            }
            else {
                type = item.type
            }
            if(type == 'ram'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.compat.capacity))
                    }
                    return capacity
                }
            }
            if(type == 'storage'){
                if(field == 'capacity'){
                    capacity = 0
                    if(length >0){
                        item.map((itm) => capacity += parseInt(itm.specs.Capacity))
                    }
                    return capacity
                }
            }
            if(type == 'graphics' || type == 'gpu'){
                if(field == 'model'){
                    var model = item.model || ''
                    if(length >0){
                        model = item[0].model
                    }
                    console.log('got model: ', model)
                    return model
                }
            }
        },
        collapse(){
            this.extend(false)
        },
        syncViewportWidth(){
            if(typeof window !== 'undefined'){
                this.viewportWidth = window.innerWidth
            }
        },
        openSavePrompt(context){
            if(this.getWidth <= 760 || this.getWidth > 1200){
                return
            }
            this.extend(true)
            this.handleSaveRequest(context)
        },
        checkPartCompat({compatTable, type}){
            var table = compatTable
            if(table && type){
                if(table[type.toLowerCase()]){
                    var fields = Object.keys(table[type.toLowerCase()])
                    if(fields && fields.length >0){
                        for(var i = 0; i < fields.length; i++){
                            if(table[type.toLowerCase()][fields[i]]){
                                var values = Object.keys(table[type.toLowerCase()][fields[i]])
                                for(var j = 0; j < values.length; j++){
                                    if(table[type.toLowerCase()][fields[i]][values[j]]
                                    && table[type.toLowerCase()][fields[i]][values[j]].compatible == false
                                    ){
                                        return false
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        // Compact menu: a native confirm rather than the inline three-way prompt
        // the full checklist shows, since there is no room for one here.
        async requestNewBuild(){
            var needsPrompt = this.buildHasParts
                && (!this.isEditingSavedBuild || this.hasUnsavedChanges)
            if(needsPrompt){
                var message = this.isEditingSavedBuild
                    ? 'You have unsaved changes to this build. Discard them and start a new build?'
                    : 'This build has not been saved to your account. Discard it and start a new one?'
                if(!window.confirm(message)){ return }
            }
            this.saveState = 'idle'
            this.buildReset()
            this.extend(false, 250)
        },
        useSuggestedName(){
            this.setDraftBuildName(this.suggestedBuildName)
            this.saveState = 'idle'
        },
        requestSignIn(){
            setPendingBuildSave()
            this.saveState = 'signin'
            this.$router.push({
                path: '/users/login',
                query: { redirect: this.$route.fullPath }
            }).catch(()=>{})
        },
        // Mirrors Menu.vue: one click saves, updating an opened build in place.
        async submitSave(){
            if(this.saveState == 'saving'){ return false }
            if(!this.buildHasParts){ return false }
            if(this.loggedIn != 'true'){
                this.requestSignIn()
                return false
            }
            if(!this.canSaveBuild){ return false }

            // Naming is the user's call; the full checklist offers the processor
            // name as a one-click suggestion.
            var name = (this.getDraftBuildName || '').trim()
            if(!name){
                this.saveState = 'name-required'
                return false
            }

            var user = this.$store.getters.getUser
            if(typeof user == 'string'){
                try { user = JSON.parse(user) } catch(e) { user = null }
            }
            if(!user || !user.id){
                this.requestSignIn()
                return false
            }

            this.saveState = 'saving'
            this.$store.dispatch('setError', null)
            this.$store.dispatch('setBuildAdded', null)

            var payload = Object.assign({ name: name, author_id: user.id }, this.getBuildRaw)
            var response = this.isEditingSavedBuild
                ? await this.updateSavedBuild(payload)
                : await this.saveBuild(payload)

            var ok = !!response && this.getError === null
            this.saveState = ok ? 'saved' : 'error'
            this.saveErrorText = ok ? '' : (typeof this.getError == 'string' ? this.getError : 'Could not save this build. Please try again.')
            this.$store.dispatch('setBuildAdded', null)

            if(ok){
                if(this.saveStatusTimer){ clearTimeout(this.saveStatusTimer) }
                this.saveStatusTimer = setTimeout(() => {
                    if(this.saveState == 'saved'){ this.saveState = 'idle' }
                }, 6000)
            }
            return ok
        },
        async handleSaveRequest(context){
            this.saveRequestContext = context && context.source ? context : null
            var ok = await this.submitSave()
            if(this.saveRequestContext){
                var saveContext = this.saveRequestContext
                this.saveRequestContext = null
                EventBus.$emit(ok ? 'build-save-succeeded' : 'build-save-cancelled', saveContext)
            }
        },
    },
    mounted(){
        this.syncViewportWidth()
        EventBus.$on('request-build-save', this.openSavePrompt)
        // Only one menu resumes a pending save; the full checklist owns it above
        // 1200px, this one below.
        if(this.loggedIn == 'true' && this.getWidth <= 1200 && consumePendingBuildSave()){
            this.$nextTick(() => { this.submitSave() })
        }
        this.getPrice()
        this.compatTableReset()
        this.buildPerformance = this.getPerformance(this.allMenuOptions).Total
        this.syncMetricTargets(true)
        if(typeof window !== 'undefined'){
            window.addEventListener('resize', this.syncViewportWidth)
        }
    },
    updated(){
        this.syncMetricTargets()
        if(this.warnings && this.warnings.length > 0){
            this.updateBuildStatus({status: 'warning'})
        }
    },
    beforeDestroy() {
        EventBus.$off('request-build-save', this.openSavePrompt)
        if(this.metricAnimationFrame && typeof window !== 'undefined' && window.cancelAnimationFrame){
            window.cancelAnimationFrame(this.metricAnimationFrame)
        }
        if(typeof window !== 'undefined'){
            window.removeEventListener('resize', this.syncViewportWidth)
        }
        if(this.saveStatusTimer){
            clearTimeout(this.saveStatusTimer)
        }
    }
}
</script>

<style scoped>
.compact-build-checklist {
    color: #cfd2da;
}

.menu-optoins-buttons {
    padding: 10px 14px 14px;
}

.menu-toggle-row.menu-option {
    display: flex;
    justify-content: flex-end;
    height: auto;
    min-height: 40px;
    margin: 0 8px 6px;
    padding: 6px 0 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    text-align: right;
}

.compact-status-indicator {
    position: absolute;
    top: 50%;
    right: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    transform: translateY(-50%);
}

.indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.indicator .icon {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.9;
    transition: color 160ms ease, opacity 160ms ease, transform 160ms ease;
}

.indicator .icon:hover,
.indicator .icon.active {
    opacity: 1;
    transform: translateY(-1px);
}

.indicate-ok {
    color: #45b028;
    text-shadow: 0 0 14px rgba(69, 176, 40, 0.5);
}

.warning-switch,
.indicate-warning {
    color: #cfb027;
    text-shadow: 0 0 14px rgba(207, 176, 39, 0.5);
}

.indicate-sad {
    color: #e64759;
    text-shadow: 0 0 14px rgba(230, 71, 89, 0.5);
}

.menu-toggle-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(25, 151, 198, 0.72);
    border-radius: 8px;
    outline: none;
    background: rgba(25, 151, 198, 0.08);
    color: #20c8f8;
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.menu-toggle-button:hover,
.menu-toggle-button:focus {
    border-color: rgba(32, 200, 248, 0.9);
    background: rgba(25, 151, 198, 0.16);
    box-shadow: 0 0 18px rgba(25, 151, 198, 0.16);
    color: #f4f8fb;
}

.menu-toggle-button .menu-link {
    width: auto;
    height: auto;
    margin: 0 !important;
    color: inherit;
    font-size: 20px;
    line-height: 1;
    transition: transform 160ms ease;
}

.menu-toggle-button.is-expanded .menu-link {
    transform: rotate(180deg);
}

.build-metrics {
    display: flex;
    flex-direction: column;
    gap: 0.82rem;
    margin: 0.72rem 14px 0;
    padding: 0.72rem;
    border: 1px solid rgba(67, 72, 87, 0.74);
    border-radius: 7px;
    background: rgba(8, 10, 15, 0.48);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}

.metric {
    width: 100%;
}

.metric-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.65rem;
    margin-bottom: 0.38rem;
}

.metric-label {
    display: inline-flex;
    align-items: center;
    gap: 0.38rem;
    color: #9198aa;
    font-size: 12px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
}

.metric-value {
    color: #cfd2da;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
}

.metric-value.perf-value {
    color: #20c8f8;
}

.perf-max {
    font-size: 10px;
    opacity: 0.62;
}

.metric-info {
    color: #687084;
    font-size: 11px;
    cursor: pointer;
}

.metric-track {
    width: 100%;
    height: 6px;
    overflow: hidden;
    border-radius: 999px;
    background: rgba(67, 72, 87, 0.58);
}

.metric-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 260ms ease, background 160ms ease;
}

.perf-fill {
    background: #1997c6;
}
.col-menu-icon {
  display:block;
}
.b-icon {
    margin-bottom: -4px;
    fill: #9198aa;
}
.b-icon.selected {
    fill: #00bc8c;
    color: #00bc8c;
}
.option-active {
    border-color: #1997c6 !important;
}
.option-active span{
    border-color: #1997c6 !important;
    color: #1997c6;
}
.power {
    margin-top: -2px !important;
}
.menu-option{
    font-size: 14pt;
    border: 1px solid #434857;
    padding: 4px;
    margin-bottom: 10px;
    border-radius: 6px;
    position: relative;
    text-align: center;
    height: 42px;
    transition: 0.2s;
    cursor: pointer;
    list-style: none;
    margin-left: 10px;
    margin-right: 10px;
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
    position: relative;
}
.build-item-link {
    min-width: 0;
    max-width: 100%;
    padding-top: 4px;
}
.incompatible {
    color: #E64759 !important;
    fill: #E64759 !important;
}
.menu-link {
    margin-top: 2px !important;
    color: #9198aa; 
    font-size: 17pt;
    font-weight: lighter;
}
.menu-link:hover {
    text-decoration: unset;
    color: unset;
}
.is-active .b-icon{
    fill:  #1997c6;
}
.is-active .b-icon.selected {
    fill: #00bc8c;
}
.extended .menu-option{
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
}
.extended .label-link {
    flex: 0 0 auto;
}
.extended .build-item-link {
    position: relative;
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: flex-end;
    min-width: 0;
    padding-top: 0;
    padding-right: 28px;
    overflow: hidden;
}
.extended .build-item-link.is-empty {
    padding-right: 0;
}
.icon {
        margin-bottom: 2px !important;
}
.arrow-flip {
    padding: 0px;
    transform: rotate(180deg);
    text-align: right;
    margin-top: -10px !important;
    margin-right: -10px !important;
}
.item-label{
    text-align: left;
    background: transparent;
    position: inherit;
    animation: fadein 1s;
    -moz-animation: fade 1s ; /* Firefox */
    -webkit-animation: fadein 0.4s; /* Safari and Chrome */
    -o-animation: fadein 1s; /* Opera */
    color:#cfd2da;
}
.item-label.selected a{
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: inherit;
}
.build-part-name__text {
    display: block;
}
.build-unavailable-warning {
    display: inline-flex;
    flex: 0 0 20px;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    max-width: none;
    margin-left: 6px;
    padding: 0;
    overflow: visible;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #e0c07e;
    line-height: 1;
    cursor: help;
}

.build-unavailable-warning:focus-visible {
    outline: 2px solid #e0c07e;
    outline-offset: 2px;
}

.build-unavailable-warning .icon {
    margin: 0 !important;
    overflow: visible;
    font-size: 14px;
}
.btn-reset {
    position: absolute;
    right: 10px;
    bottom: unset;
    left: unset;
    max-width: 15px;
    display: inline-block;
    background: transparent;
    border: none;
    font-weight: unset;
    font-size: 10pt;
    padding-top: 7px;
    color: #434857;
    top: 6px;
}
.btn-reset:hover {
    cursor: pointer;
    color: #E6474B;
    transform: scale(1.1) !important;
    transition: 0.2s;
}
.item-label.selected .b-icon{
    fill: #00bc8c !important;
}
.item-label.selected {
    vertical-align:sub;
    margin-right: 16px;
    box-shadow: 0px 0px 4px #191b20;
    margin-top: -1px;
    font-size: 12pt;
    display: inline-block;
    animation: fadein 1s;
    -moz-animation: fade 1s ; /* Firefox */
    -webkit-animation: fadein 1s; /* Safari and Chrome */
    -o-animation: fadein 1s; /* Opera */
}
.extended .item-label.selected {
    display: block !important;
    flex: 1 1 auto;
    width: 100% !important;
    min-width: 0;
    max-width: 100%;
    margin-right: 0;
    overflow: hidden;
    text-align: right;
}
.extended .btn-reset {
    right: 0;
    top: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    max-width: 22px;
    padding: 0;
    transform: translateY(-50%);
}
.extended .btn-reset:hover {
    transform: translateY(-50%) scale(1.1) !important;
}
 .item-label.selected:hover a{
    text-decoration: none !important;
}
.item-label.not-selected{
    color: #646b7c;
    font-size: 14px !important;
    margin-right: 4px;
}
.extended .item-label.not-selected {
    display: block;
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    margin-right: 0;
    overflow: hidden;
    color: #646b7c;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.extended .item-label.not-selected:hover,
.extended .item-label.not-selected:focus {
    color: #20c8f8;
    text-decoration: none;
}

.build-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.55rem;
    margin-top: 0.72rem;
}

.build-actions a {
    min-width: 0;
    text-decoration: none;
}

.build-name-field label {
    display: block;
    text-align: center;
}

.build-name-field label span,
.build-name-required {
    color: #e0b85f;
}

.build-name-field input {
    width: 100%;
    min-height: 34px;
    margin-top: 0.35rem;
    padding: 0.4rem 0.55rem;
    border: 1px solid rgba(67, 72, 87, 0.96);
    border-radius: 6px;
    outline: none;
    background: rgba(6, 8, 12, 0.76);
    color: #e5e8ef;
    text-align: center;
}

.build-name-field input:focus {
    border-color: #1997c6;
    box-shadow: 0 0 0 3px rgba(25, 151, 198, 0.11);
}

.build-name-required {
    display: block;
    margin-top: 0.4rem;
    font-size: 11px;
    line-height: 1.3;
}

.gc-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100% !important;
    min-height: 34px;
    margin: 0;
    padding: 0 0.55rem;
    border: 1px solid rgba(25, 151, 198, 0.72);
    border-radius: 6px;
    background: rgba(25, 151, 198, 0.055);
    color: #1997c6;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
    line-height: 1;
    text-transform: uppercase;
    transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.build-actions .gc-button {
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 0.62rem !important;
    border-color: rgba(32, 184, 235, 0.78) !important;
    background:
        linear-gradient(180deg, rgba(32, 184, 235, 0.13), rgba(25, 151, 198, 0.045)) !important;
    color: #20c8f8 !important;
    font-size: 12px !important;
    font-weight: 800;
    line-height: 1 !important;
    white-space: nowrap;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.04),
        0 0 18px rgba(25, 151, 198, 0.08);
}

.gc-button:hover,
.gc-button:focus {
    border-color: #16b4ed;
    background: rgba(25, 151, 198, 0.16);
    box-shadow: 0 0 18px rgba(25, 151, 198, 0.12);
    color: #f4f8fb;
}

.build-actions .gc-button:hover,
.build-actions .gc-button:focus {
    border-color: rgba(32, 200, 248, 0.95) !important;
    background:
        linear-gradient(180deg, rgba(32, 184, 235, 0.22), rgba(25, 151, 198, 0.1)) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.06),
        0 0 20px rgba(25, 151, 198, 0.16);
}

.gc-button.inactive,
.gc-button:disabled {
    border-color: rgba(67, 72, 87, 0.82);
    background: rgba(8, 10, 15, 0.28);
    color: #687084 !important;
    cursor: not-allowed;
    box-shadow: none;
}

.build-actions .gc-button.inactive:hover,
.build-actions .gc-button.inactive:focus,
.build-actions .gc-button:disabled:hover,
.build-actions .gc-button:disabled:focus {
    border-color: rgba(67, 72, 87, 0.82) !important;
    background: rgba(8, 10, 15, 0.28) !important;
    color: #687084 !important;
    box-shadow: none;
}

@media screen and (min-width: 761px) and (max-width: 1200px) {
    .menu-toggle-row.menu-option,
    .menu-option:first-child.menu-toggle-row {
        width: auto;
        height: 42px;
        min-height: 42px;
        margin: 0.42rem 2px 0.32rem;
        padding: 0;
        border: 0;
        background: transparent;
        box-shadow: none;
    }

    .menu-option {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 52px;
        height: 52px;
        margin: 0.42rem auto;
        padding: 0;
        border-color: rgba(74, 82, 103, 0.82);
        border-radius: 8px;
        background: rgba(13, 17, 25, 0.64);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
        text-align: center;
    }

    .menu-option:first-child {
        width: auto;
        height: 32px;
        margin-top: 0.48rem;
        margin-bottom: 0.28rem;
        border-color: transparent;
        background: transparent;
        box-shadow: none;
    }

    .menu-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        margin-top: 0 !important;
        color: #8f98aa;
        line-height: 1;
    }

    .menu-link .b-icon,
    .label-link,
    .label-link span {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
    }

    .b-icon {
        margin: 0 !important;
    }

    .b-icon >>> svg {
        width: 25px;
        height: 25px;
    }

    .option-active {
        border-color: rgba(25, 151, 198, 0.84) !important;
        background: rgba(25, 151, 198, 0.13);
        box-shadow:
            inset 3px 0 0 #1997c6,
            0 0 18px rgba(25, 151, 198, 0.14);
    }

    .option-active span {
        color: #1fb2e8;
    }

    .extended .menu-option {
        width: auto;
        justify-content: space-between;
        padding: 0 0.72rem;
    }

    .collapsed-price {
        width: 100%;
        margin-top: 0.45rem;
        padding: 0.6rem 0.2rem 0.34rem;
        overflow: hidden;
        border-top: 1px solid rgba(74, 82, 103, 0.56);
    }

    .collapsed-price .build-total {
        width: 100%;
        margin-top: 0 !important;
        transform: none;
    }

    .collapsed-price >>> .totalCost {
        width: 100%;
        height: auto !important;
        justify-content: center !important;
    }

    .collapsed-price >>> .subtotal.price {
        display: inline-flex !important;
        flex-direction: row-reverse;
        align-items: flex-start;
        justify-content: center;
        max-width: 100%;
        overflow: hidden;
        font-variant-numeric: tabular-nums;
    }

    .collapsed-price >>> .price-tag {
        float: none !important;
        max-width: 50px;
        margin: 0 !important;
        overflow: hidden;
        color: #e4d836 !important;
        font-size: 20px !important;
        font-weight: 500 !important;
        line-height: 1 !important;
        text-overflow: clip;
    }

    .collapsed-price >>> .dollar-sign {
        float: none !important;
        margin: 0.05rem 0.08rem 0 0 !important;
        color: #9198aa !important;
        font-size: 12px !important;
        line-height: 1 !important;
    }
}

@media screen and (min-width: 761px) and (max-width: 900px) {
    .menu-option {
        width: 48px;
        height: 48px;
        margin-top: 0.36rem;
        margin-bottom: 0.36rem;
    }

    .b-icon >>> svg {
        width: 23px;
        height: 23px;
    }

    .collapsed-price >>> .price-tag {
        max-width: 46px;
        font-size: 19px !important;
    }
}
</style>
